import React, { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { InputField } from "../../../../Components/formElements/InputField";
import { Col, Row } from "react-bootstrap";
import DataTable from "react-data-table-component";
import toast from "react-hot-toast";

//Redux
import { useSelector } from "react-redux"; //useDispatch

//Service
import ItemService from "../../../../services/customer_appCommonService";
import ItemServiceV2 from "../../../../services/customer_v2_appCommonService";
import {
  formatDateWithAMPM,
  getTodayDate,
  validateContactNumber,
  validateRequired,
  validPostalCode,
  // validateRequired,
  // validPostalCode,
} from "../../../../common/Validations";
import MaterialSelectionModal from "./MaterialSelectionModal";
import { ComboboxField } from "../../../../Components/formElements/ComboboxField";
import { TextAreaField } from "../../../../Components/formElements/TextAreaField";
import TableDropdownMenu from "../../../../Components/TableDropdownMenu/TableDropdownMenu";
import CreditPolicyRequestFormOrderBookingModal from "../CreditPolicy/CreditPolicyRequestFormOrderBookingModal";
import FailureModal from "../../../../Components/Modal/supplier_app/FailureModal";
import { TableStatusField } from "../../../../Components/formElements/TableStatusField";

const message = {
  VALID_CUSTOMER_NAME: "Special characters or numbers are not allowed.",
  VALID_MAIL_ID: "Please enter a valid email address.",
  VALID_ALTERNATE_MAIL_ID: "Please enter a valid alternate email address.",
  VALID_CONTACT_NUMBER: "Please enter a valid contact number.",
  VALID_ALTERNATE_CONTACT_NUMBER:
    "Please enter a valid alternate contact number.",
  VALID_PURPOSE_JUSTIFICATION:
    "Please ensure the justification is under 500 characters.",
  VALID_POSTAL_CODE: "Enter a 6-character postal code.",
  VALID_CONTACT_FIRST_NAME: "Special characters and numbers are not allowed",
  VALID_CONTACT_LAST_NAME: "Special characters and numbers are not allowed",
  EXIStS_MAIL_ID: "Email already exists",
  EXIStS_CONTACT_NUMBER: "Contact Number already exists",
  EXIStS_ALTERNATE_CONTACT_NUMBER: "Contact Number already exists",
  EXIStS_ALTERNATE_MAIL_ID: "Alternate Contact Number already exists",
  FILL_REQUIRED_FIELD: "Please fill the required field",
  ALTERNATE_MAIL_ID: "Email ID is same",
  ALTERNATE_CONTACT_NUMBER: "Contact number is same",
  GET_MAP_DISTANCE: "Please Click the Get Distance & Time button",
};

const OrderSchedulingModal = React.forwardRef((props, ref) => {
  let userData = useSelector((state) => state?.user?.data);

  // const [getUserId, setUserId] = useState();

  const exForDropdownData = [
    { id: 1, name: "Ex-Work" },
    { id: 2, name: "FOR" },
  ];

  let productDetailsCol = [
    {
      name: "Sl.No",
      selector: (row) => row.local_id || "--",
      cell: (row) => <>{row.local_id}.</>,
      sortable: true,
      width: "80px",
    },
    {
      name: "Material",
      selector: (row) => row.materialLongText,
      sortable: true,
      width: "120px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold text-primary">
            {row.materialLongText}{" "}
          </p>
          <p className="m-0 p-0 ">{row.materialCode} </p>
        </div>
      ),
    },
    {
      name: "A/C",
      selector: (row) => row.accOnOff,
      sortable: true,
      width: "120px",
      cell: (row) => (
        <div className="form-check form-switch">
          <input
            className="form-check-input custom-switch"
            type="checkbox"
            role="switch"
            id={`switch-${row.local_id}`}
            checked={row.accOnOff === true}
            onChange={(event) => handleCheckboxChange(row.local_id, event)}
          />
        </div>
      ),
    },
    {
      name: "UOM",
      selector: (row) => row.uOM || "--",
      sortable: true,
      width: "100px",
    },
    {
      name: "Qty",
      selector: (row) => row.orderQuantityLoad || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="orderQuantityLoad"
          placeholder=""
          value={row.orderQuantityLoad || ""}
          // disabled={true}
          onChange={(event) => handleInputChange(row.local_id, event, "Number")}
        />
      ),
      sortable: true,
      width: "100px",
    },
    {
      name: "Unit Price",
      selector: (row) => row.unitPrice || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="unitPrice"
          placeholder=""
          value={row.unitPrice || ""}
          // disabled={true}
          onChange={(event) => handleInputChange(row.local_id, event, "Number")}
        />
      ),
      sortable: true,
      width: "130px",
    },
    {
      name: "EX/FOR",
      cell: (row) => (
        <>
          <TableDropdownMenu
            index={row?.local_id}
            label={"EX/FOR"}
            data={exForDropdownData}
            id={"exWork"}
            name={"exWork"}
            code={"exWorkCode"}
            description={"exWorkDescription"}
            onChange={handleDropdownChange}
            // required={true}
          />
          {/* {viewStatus ? (
            <InputField
              className="inputBox"
              // label="Godown"
              name="godownAddress"
              id="godownAddress"
              value={row.godownAddress}
              // onChange={(event) => handleInputChange(row?.local_id, event)}
              disabled={viewStatus}
            />
            
          ) : (
            <TableDropdownMenu
              index={row?.local_id}
              label={"Godown"}
              data={exForDropdownData}
              id={"godownAddress"}
              name={"godownAddress"}
              code={"godownAddressCode"}
              description={"godownAddressDescription"}
              onChange={handleDropdownChange}
              // required={true}
            />
          )} */}
        </>
      ),
      sortable: true,
      width: "200px",
    },
    {
      name: "Truck Nr",
      selector: (row) => row.loadingTruckNo || "--",
      cell: (row) => (
        <>
          {row?.exWork === "Ex-Work" ? (
            <>
              <InputField
                className="inputBox"
                name="loadingTruckNo"
                id="loadingTruckNo"
                value={row?.loadingTruckNo}
                // disabled={viewStatus}
                onChange={(event) => handleInputChange(row.local_id, event)}
              />
            </>
          ) : (
            <>--</>
          )}
        </>
      ),
      sortable: true,

      width: "200px",
    },
    {
      name: "Priority",
      cell: (row) => (
        <>
          <TableDropdownMenu
            index={row?.local_id}
            label={"Priority"}
            data={priority}
            id={"priority"}
            name={"priority"}
            code={"priorityCode"}
            description={"priorityDescription"}
            onChange={handleDropdownChange}
          />
        </>
      ),
      sortable: true,
      width: "200px",
    },
    {
      name: "Dispatch Date",
      selector: (row) => row.dispatchDate || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="dispatchDate"
          type="date"
          placeholder=""
          value={row.dispatchDate || getTodayDate("")}
          disabled={false}
          onChange={(event) => handleInputChange(row.local_id, event)}
        />
      ),
      width: "200px",
    },

    {
      name: "Shipping Address",
      selector: (row) => row.netValue || "--",
      cell: (row) => (
        <>
          {/* <TextAreaField
           className="inputBox mt-1"
           name="shippingAddress"
           placeholder=""
           value={row.shippingAddress || ""}
           onChange={(event) => handleInputChange(row.local_id, event)}
           disabled={false}
         /> */}
          <TextAreaField
            className="inputBox mt-1"
            name="shippingAddress"
            placeholder=""
            value={row.isShippingEdited ? row.shippingAddress : ""}
            onChange={(event) => handleInputChange(row.local_id, event)}
          />
        </>
      ),
      sortable: true,
      width: "200px",
    },
    {
      name: "Pin Code",
      selector: (row) => row.netValue || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="shippingPostalCode"
          placeholder=""
          value={row.isPostalEdited ? row.shippingPostalCode : ""}
          onChange={(event) => handleInputChange(row.local_id, event, "Number")}
        />
      ),
      sortable: true,
      width: "200px",
    },
    // {
    //   name: "CGST%",
    //   selector: (row) => row.cgst || "--",
    //   sortable: true,
    //   width: "100px",
    // },
    // {
    //   name: "SGST%",
    //   selector: (row) => row.sgst || "--",
    //   sortable: true,
    //   width: "100px",
    // },
    {
      name: "Remarks",
      cell: (row) => (
        <TextAreaField
          className="inputBox mt-1"
          name="dispatchRemarks"
          placeholder=""
          value={row.dispatchRemarks || ""}
          onChange={(event) => handleInputChange(row.local_id, event, "Text")}
        />
      ),
      sortable: true,
      width: "200px",
    },
    {
      name: "Delete",
      selector: (row) => row.local_id || "--",
      sortable: true,
      cell: (row) => (
        <button className="" onClick={() => removeProductDetails(row.local_id)}>
          <i className="bi bi-trash text-danger fs-4" />
        </button>
      ),
      width: "120px",
    },
  ];

  const defaultCustomerDetails = {
    customerName: "",
    address: "",
    address2: "",
    address3: "",
    state: "",
    cityPostalCode: "",
    certifications: "",
  };
  const failureModalData = {
    title: "Warning",
    ErrorMsg: "",
  };
  const priority = [
    { id: 1, code: "LH", name: "Load and Halt" },
    { id: 2, code: "CON", name: "Concrete" },
    { id: 3, code: "CE", name: "Customer Emergency" },
    { id: 4, code: "MED", name: "Medium" },
  ];
  const [modalShow, setModalShow] = useState(false);
  const [isCardVisible1, setCardVisible1] = useState(true);
  const [isCardVisible2, setCardVisible2] = useState(true);
  const [isCardVisible3, setCardVisible3] = useState(true);
  const [addOnInv, setAddOnInv] = useState(false);
  const addOnInvoiceChange = (event) => {
    setAddOnInv(event.target.checked);
  };

  const [getDropdownData, setDropdownData] = useState("");
  const [getProductDetailsData, setProductDetailsData] = useState([]); //productDetailsData

  const [getProductDetailsCol] = useState(productDetailsCol);

  const [disable, setDisabled] = useState(false);
  const [getCustomer, setCustomer] = useState([]);
  const [getCompanyCode, setCompanyCode] = useState([]);
  // eslint-disable-next-line no-unused-vars
  const [getProjects, setProjects] = useState([]);
  const [getCustomerDetails, setCustomerDetails] = useState(null);
  const [getCompanyDetails, setCompanyDetails] = useState(null);
  // eslint-disable-next-line no-unused-vars
  const [getProjectDetails, setProjectDetails] = useState([]);
  const [getProjectDetailsSave, setProjectDetailsSave] = useState([]);
  const [customerID, setCustomerID] = useState("");
  const [orderTotalValue, setOrderTotalValue] = useState(0);

  const [getShowFailureModal, setShowFailureModal] = useState(false);

  const [getErrorFields, setErrorFields] = useState([]);
  const [getFailureModal] = useState(failureModalData);

  const [getCreditPolicyFormModal, setCreditPolicyFormModal] = useState(false);
  const [toggleCreditRequest, setToggleCreditRequest] = useState(false);

  const toggleCardVisibility1 = () => {
    setCardVisible1(!isCardVisible1);
  };
  const toggleCardVisibility3 = () => {
    setCardVisible3(!isCardVisible3);
  };
  // for getting credit data

  const [formInputs, setFormInputs] = useState({
    orderStatus: "Pending",
    orderPlacedBy: "",
    customerDetails: "",
    emailAddress: "",
    deliveryAddress: "",
    customerDetailsIfOther: "",
    additionalCreditAmt: "",
    createdDate: new Date(),
    createdBy: userData?.userId,

    dispatchDate: getTodayDate(""),
  });

  /* pop failure modal */
  const [validation, setValidation] = useState({});

  const toggleCardVisibility2 = () => {
    setCardVisible2(!isCardVisible2);
  };

  useEffect(() => {
    if (props.show) {
      loadMasterData();
      setOrderTotalValue(0);
      setFormInputs({
        orderStatus: "Pending",
        orderPlacedBy: "",
        customerDetails: "",
        emailAddress: "",
        deliveryAddress: "",
        customerDetailsIfOther: "",
        createdDate: new Date(),
        createdBy: userData?.userId,
        dispatchDate: getTodayDate(""),
        // shippingAddress: "",
      });

      setProductDetailsData([]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.show]);

  useEffect(() => {
    if (getDropdownData?.textCode === "customerCode") {
      setFormInputs((formInputs) => ({
        ...formInputs,
        [getDropdownData?.textField]: getDropdownData?.name,
        [getDropdownData?.textCode]: getDropdownData?.id,
        [getDropdownData?.textDesc]: getDropdownData?.description,
        sapDocumentNumber: getDropdownData?.sapDocumentNumber,
      }));
      getProjectNameData(getDropdownData?.id);
      getCustomerDetail(getDropdownData?.id);
      setCustomerID(getDropdownData?.id);
      setFormInputs((formInputs) => ({ ...formInputs, projectName: "" }));
      setProjectDetails([]);
      setProjectDetailsSave([]);
    } else if (getDropdownData?.textCode === "projectNameCode") {
      setFormInputs((formInputs) => ({
        ...formInputs,
        [getDropdownData?.textField]: getDropdownData?.name,
        [getDropdownData?.textCode]: getDropdownData?.id,
        [getDropdownData?.textDesc]: getDropdownData?.description,
        sapProjectCode: getDropdownData?.sapProjectCode,
      }));
      // getProjectDetailsByCode(getDropdownData?.id);
    } else if (getDropdownData?.textCode === "companyCode") {
      setFormInputs((formInputs) => ({
        ...formInputs,
        [getDropdownData?.textField]: getDropdownData?.name,
        [getDropdownData?.textCode]: getDropdownData?.id,
        [getDropdownData?.textDesc]: getDropdownData?.description,
        sapProjectCode: getDropdownData?.sapProjectCode,
      }));
      getCompanyMaster(getDropdownData?.id);
      customerDataDropdown(getDropdownData?.id);
    } else {
      setFormInputs((formInputs) => ({
        ...formInputs,
        [getDropdownData?.textField]: getDropdownData?.name,
        [getDropdownData?.textCode]: getDropdownData?.code,
        [getDropdownData?.textDesc]: getDropdownData?.description,
      }));
    }
    setValidation((prev) => ({
      ...prev,
      [getDropdownData?.textField]: "",
    }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getDropdownData]);

  //others toggle
  const [othersCustomer, setOthersCustomer] = useState(false); // default false
  const onCheckBoxChange = (event) => {
    setOthersCustomer(event.target.checked);
    setCustomerDetails(defaultCustomerDetails);
  };

  const removeProductDetails = (local_id) => {
    setProductDetailsData((prevPrograms) => {
      const filteredData = prevPrograms.filter(
        (program) => program.local_id !== local_id,
      );
      // Reset and update `local_id` sequentially
      const updatedData = filteredData.map((item, index) => ({
        ...item,
        local_id: index + 1, // Reset local_id after removal
        orderQuantityLoad: "",
      }));
      return updatedData;
    });
  };
  // const handleInputChange = (local_id, event, type) => {
  //   const { name, value } = event.target;

  //   setProductDetailsData(prev =>
  //     prev.map(row => {
  //       if (row.local_id === local_id) {

  //         // Validation
  //         if (type === "Number" && isNaN(value)) {
  //           toast.error("Please enter a valid number");
  //           return row;
  //         }

  //         let updatedRow = { ...row, [name]: value };

  //         // Mark as edited so UI will show typed value
  //         if (name === "shippingAddress") {
  //           updatedRow.isShippingEdited = true;

  //           // default address if user clears input
  //           if (!value.trim()) {
  //             updatedRow.shippingAddress = updatedRow.originalShippingAddress;;
  //           }
  //         }

  //         if (name === "shippingPostalCode") {
  //           updatedRow.isPostalEdited = true;

  //           if (!value.trim()) {
  //             updatedRow.shippingPostalCode =  Number(updatedRow.originalShippingPostalCode);
  //           }
  //         }

  //         // Existing calculations...
  //         // (keep your calculation code unchanged)
  //         const updatedRows = prev.map((row) => {
  //         if (row.local_id === local_id) {
  //           const updatedRow = { ...row, [name]: value };

  //           // Ensure orderQuantityLoad, unitPrice, reversePercentage, basicPrice, and basicAmount are valid numbers
  //           const orderQuantityLoad =
  //             parseFloat(updatedRow?.orderQuantityLoad) || 0;
  //           const unitPrice = parseFloat(updatedRow?.unitPrice) || 0;

  //           const reversePercentage = parseFloat(updatedRow.reversePercentage);
  //           const cgst = parseFloat(updatedRow.cgst);
  //           const sgst = parseFloat(updatedRow.sgst);
  //           const gst = parseFloat(cgst) + parseFloat(sgst);
  //           updatedRow.gst = gst;

  //           updatedRow.basicPrice =
  //             parseFloat(unitPrice) / parseFloat(reversePercentage);

  //           // Calculate basicAmount if basicPrice & orderQuantityLoad are valid
  //           if (!isNaN(updatedRow.basicPrice) && !isNaN(orderQuantityLoad)) {
  //             updatedRow.basicAmount = (
  //               updatedRow.basicPrice * orderQuantityLoad
  //             ).toFixed(2);
  //           }

  //           // Calculate rate if orderQuantityLoad & unitPrice are valid
  //           if (!isNaN(orderQuantityLoad) && !isNaN(unitPrice)) {
  //             updatedRow.rate = (orderQuantityLoad * unitPrice).toFixed(2);
  //           }

  //           // Calculate basicPrice if reversePercentage & unitPrice are valid and reversePercentage is not zero
  //           if (
  //             !isNaN(reversePercentage) &&
  //             !isNaN(unitPrice) &&
  //             reversePercentage !== 0
  //           ) {
  //             updatedRow.basicPrice = (unitPrice / reversePercentage).toFixed(2);
  //           }

  //           if (!isNaN(updatedRow.basicAmount)) {
  //             updatedRow.cgstValue = (
  //               (cgst * updatedRow.basicAmount) /
  //               100
  //             ).toFixed(2);
  //           }

  //           if (!isNaN(sgst) && !isNaN(updatedRow.basicAmount)) {
  //             updatedRow.sgstValue = (
  //               (sgst * updatedRow.basicAmount) /
  //               100
  //             ).toFixed(2);
  //           }

  //           updatedRow.gstValue = ((gst * updatedRow.basicAmount) / 100).toFixed(
  //             2
  //           );
  //           updatedRow.netValue = parseFloat(
  //             parseFloat(updatedRow.gstValue) + parseFloat(updatedRow.basicAmount)
  //           ).toFixed(2);

  //           return updatedRow;
  //         }
  //         return row;
  //       });

  //       //  Calculate total after updates
  //       const total = updatedRows.reduce((acc, row) => {
  //         const qty = parseFloat(row.orderQuantityLoad) || 0;
  //         const price = parseFloat(row.unitPrice) || 0;
  //         return acc + qty * price;
  //       }, 0);

  //       setOrderTotalValue(total.toFixed(2));

  //         return updatedRow;
  //       }
  //       return row;
  //     })
  //   );
  // };

  // const handleInputChange = (local_id, event, type) => {
  //   const { name, value } = event.target;

  //   if (type === "Number" && isNaN(value)) {
  //     toast.error("Please enter a valid number");
  //     return;
  //   }

  //   setProductDetailsData((prevRows) => {
  //     const updatedRows = prevRows.map((row) => {
  //       if (row.local_id === local_id) {
  //         const updatedRow = { ...row, [name]: value };

  //         // Ensure orderQuantityLoad, unitPrice, reversePercentage, basicPrice, and basicAmount are valid numbers
  //         const orderQuantityLoad =
  //           parseFloat(updatedRow?.orderQuantityLoad) || 0;
  //         const unitPrice = parseFloat(updatedRow?.unitPrice) || 0;

  //         const reversePercentage = parseFloat(updatedRow.reversePercentage);
  //         const cgst = parseFloat(updatedRow.cgst);
  //         const sgst = parseFloat(updatedRow.sgst);
  //         const gst = parseFloat(cgst) + parseFloat(sgst);
  //         updatedRow.gst = gst;

  //         updatedRow.basicPrice =
  //           parseFloat(unitPrice) / parseFloat(reversePercentage);

  //         // Calculate basicAmount if basicPrice & orderQuantityLoad are valid
  //         if (!isNaN(updatedRow.basicPrice) && !isNaN(orderQuantityLoad)) {
  //           updatedRow.basicAmount = (
  //             updatedRow.basicPrice * orderQuantityLoad
  //           ).toFixed(2);
  //         }

  //         // Calculate rate if orderQuantityLoad & unitPrice are valid
  //         if (!isNaN(orderQuantityLoad) && !isNaN(unitPrice)) {
  //           updatedRow.rate = (orderQuantityLoad * unitPrice).toFixed(2);
  //         }

  //         // Calculate basicPrice if reversePercentage & unitPrice are valid and reversePercentage is not zero
  //         if (
  //           !isNaN(reversePercentage) &&
  //           !isNaN(unitPrice) &&
  //           reversePercentage !== 0
  //         ) {
  //           updatedRow.basicPrice = (unitPrice / reversePercentage).toFixed(2);
  //         }

  //         if (!isNaN(updatedRow.basicAmount)) {
  //           updatedRow.cgstValue = (
  //             (cgst * updatedRow.basicAmount) /
  //             100
  //           ).toFixed(2);
  //         }

  //         if (!isNaN(sgst) && !isNaN(updatedRow.basicAmount)) {
  //           updatedRow.sgstValue = (
  //             (sgst * updatedRow.basicAmount) /
  //             100
  //           ).toFixed(2);
  //         }

  //         updatedRow.gstValue = ((gst * updatedRow.basicAmount) / 100).toFixed(
  //           2
  //         );
  //         updatedRow.netValue = parseFloat(
  //           parseFloat(updatedRow.gstValue) + parseFloat(updatedRow.basicAmount)
  //         ).toFixed(2);

  //         return updatedRow;
  //       }
  //       return row;
  //     });

  //     //  Calculate total after updates
  //     const total = updatedRows.reduce((acc, row) => {
  //       const qty = parseFloat(row.orderQuantityLoad) || 0;
  //       const price = parseFloat(row.unitPrice) || 0;
  //       return acc + qty * price;
  //     }, 0);

  //     setOrderTotalValue(total.toFixed(2)); // 💰 Update total state
  //     return updatedRows;
  //   });
  // };

  const handleInputChange = (local_id, event, type) => {
    const { name, value } = event.target;

    setProductDetailsData((prev) => {
      const updatedRows = prev.map((row) => {
        if (row.local_id !== local_id) return row;

        // Validation
        if (type === "Number" && isNaN(value)) {
          toast.error("Please enter a valid number");
          return row;
        }

        let updatedRow = { ...row, [name]: value };

        // ----- Shipping Address Logic -----
        // if (name === "shippingAddress") {
        //   updatedRow.isShippingEdited = true;
        //   if (!value.trim()) {
        //     updatedRow.shippingAddress = updatedRow.originalShippingAddress;
        //   }
        // }

        // if (name === "shippingPostalCode") {
        //   updatedRow.isPostalEdited = true;
        //   if (!value.trim()) {
        //     updatedRow.shippingPostalCode = Number(updatedRow.originalShippingPostalCode);
        //   }
        // }
        // ----- Shipping Address Logic -----
        if (name === "shippingAddress") {
          updatedRow.isShippingEdited = true;

          if (value.trim()) {
            // Address entered → CLEAR postal code
            updatedRow.shippingPostalCode = "";
            updatedRow.isPostalEdited = true;
          } else {
            // Address cleared → restore defaults
            updatedRow.shippingAddress = updatedRow.originalShippingAddress;
            updatedRow.shippingPostalCode =
              updatedRow.originalShippingPostalCode || "";
            updatedRow.isPostalEdited = false;
          }
        }

        // ----- Shipping Postal Code Logic -----
        if (name === "shippingPostalCode") {
          updatedRow.isPostalEdited = true;
          updatedRow.shippingPostalCode = value; // ❗ no auto restore
        }

        // ----- PRICE CALCULATIONS -----
        const qty = parseFloat(updatedRow.orderQuantityLoad) || 0;
        const price = parseFloat(updatedRow.unitPrice) || 0;

        const reversePercentage = parseFloat(updatedRow.reversePercentage) || 1;
        const cgst = parseFloat(updatedRow.cgst) || 0;
        const sgst = parseFloat(updatedRow.sgst) || 0;

        const gst = cgst + sgst;
        updatedRow.gst = gst;

        updatedRow.basicPrice = price / reversePercentage || 0;
        updatedRow.basicAmount = (updatedRow.basicPrice * qty).toFixed(2);

        updatedRow.cgstValue = ((cgst * updatedRow.basicAmount) / 100).toFixed(
          2,
        );
        updatedRow.sgstValue = ((sgst * updatedRow.basicAmount) / 100).toFixed(
          2,
        );
        updatedRow.gstValue = ((gst * updatedRow.basicAmount) / 100).toFixed(2);

        updatedRow.rate = (qty * price).toFixed(2);

        updatedRow.netValue = (
          parseFloat(updatedRow.basicAmount) + parseFloat(updatedRow.gstValue)
        ).toFixed(2);

        return updatedRow;
      });

      // ---- TOTAL CALCULATION MOVED INSIDE SAME CALLBACK ----
      const total = updatedRows.reduce((sum, row) => {
        const qty = parseFloat(row.orderQuantityLoad) || 0;
        const price = parseFloat(row.unitPrice) || 0;
        return sum + qty * price;
      }, 0);

      setOrderTotalValue(total.toFixed(2));

      return updatedRows;
    });
  };

  const othersOnInputChange = ({ target: { name, value } }) => {
    const errors = {};

    setCustomerDetails((customerDetails) => ({
      ...customerDetails,
      [name]: value,
    }));
    setValidation((prev) => ({
      ...prev,
      [name]: errors[name] || "",
    }));
  };
  // current outstanding limit caluclation

  //eslint-disable-next-line
  const [currentOutstandingAmt, setCurrentOutstandingAmt] = useState(0);

  useEffect(() => {
    const maxLimit =
      Number(getCustomerDetails?.companyProfile?.creditMaxLimit) || 0;
    const available =
      Number(getCustomerDetails?.companyProfile?.creditAvailableAmt) || 0;

    const outstanding = maxLimit - available;

    setCurrentOutstandingAmt(outstanding.toFixed(2));
  }, [getCustomerDetails]);

  /* handle save */
  const handleSave = async () => {
    // const requiredFields = [];
    // const anyFieldNotEmpty = Object.values(validation).some(
    //   (value) => value !== null && value !== ""
    // );
    // if (anyFieldNotEmpty) {
    //   requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
    //   return;
    // }

    // if (!validateRequired(formInputs.shippingPostalCode)) {
    //   requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
    //   setValidation((prev) => ({
    //     ...prev,
    //     shippingPostalCode: message.FILL_REQUIRED_FIELD,
    //   }));
    //   return;
    // }

    // if (!validPostalCode(formInputs.shippingPostalCode)) {
    //   requiredFields.push(`${message.VALID_POSTAL_CODE}`);
    //   setValidation((prev) => ({
    //     ...prev,
    //     shippingPostalCode: message.VALID_POSTAL_CODE,
    //   }));
    //   return;
    // }

    if (getProductDetailsData.length === 0) {
      toast.error("Please add atleast one record!", {
        duration: 4000,
        position: "top-right",
      });
      return;
    }

    const finalobj = getProductDetailsData.map((item) => ({
      ...item,
      ...formInputs,
    }));

    // const filteredData = finalobj
    //   .map(({ _id, ...rest }) => rest) // Remove _id field
    //   .filter((item) => item.orderQuantityLoad?.trim() !== "" );

    // if (filteredData.length === 0) {
    //   toast.error("Bag value should not be empty !!", {
    //     duration: 4000,
    //     position: "top-right",
    //   });
    //   return;
    // }

    const filteredData = finalobj.map(({ _id, ...rest }) => rest);
    // Check if any item has empty orderQuantityLoad
    const hasEmptyOrderQuantityLoad = filteredData.some(
      (item) =>
        !item.orderQuantityLoad ||
        item.orderQuantityLoad.toString().trim() === "",
    );

    // Check if any item has empty unitPrice (strict check)
    const hasEmptyUnitPrice = filteredData.some(
      (item) =>
        item.unitPrice === undefined ||
        item.unitPrice === null ||
        item.unitPrice.toString().trim() === "" ||
        Number(item.unitPrice) === 0,
    );
    const hasMissingTruckNo = filteredData.some(
      (item) =>
        item.exWork === "Ex-Work" &&
        (!item.loadingTruckNo || item.loadingTruckNo.toString().trim() === ""),
    );

    if (hasMissingTruckNo) {
      toast.error("Truck No is required for Ex-Work orders!", {
        position: "top-right",
        autoClose: 4000,
      });
      return;
    }

    if (hasEmptyOrderQuantityLoad) {
      toast.error("Bag value should not be empty !!", {
        duration: 4000,
        position: "top-right",
      });
      return;
    }

    if (hasEmptyUnitPrice) {
      toast.error("Unit price should not be empty or zero !!", {
        duration: 4000,
        position: "top-right",
      });
      return;
    }

    const invalidShippingRow = finalobj.find(
      (row) =>
        row.shippingAddress?.trim() && // address entered
        !row.shippingPostalCode?.toString().trim(), // postal missing
    );

    if (invalidShippingRow) {
      toast.error("Please fill the Shipping Postal Code", {
        duration: 4000,
        position: "top-right",
      });
      return;
    }

    const obj = {
      data: {
        companyCode: filteredData[0].companyCode,
        companyCodeDesc: filteredData[0].companyCodeDesc,
        customerCode: filteredData[0].customerCode || "",
        customerName:
          filteredData[0].customerName || getCustomerDetails?.customerName,
        deliveryName: filteredData[0].projectName,

        address: getCustomerDetails?.address,
        address2: getCustomerDetails?.address2,
        address3: getCustomerDetails?.address3,
        state: getCustomerDetails?.state,
        cityPostalCode: getCustomerDetails?.cityPostalCode,
        certifications: getCustomerDetails?.certifications,

        creditLimitAmt: parseFloat(getCustomerDetails?.creditLimitAmt) || "",
        creditOutStandingAmt:
          parseFloat(getCustomerDetails?.creditOutStandingAmt) || "",
        creditAvailableAmt:
          parseFloat(getCustomerDetails?.creditAvailableAmt) || "",
        creditLimitExpiryDate: getCustomerDetails?.creditLimitExpiryDate || "",
        creditPeriod: getCustomerDetails?.creditPeriod || "",
        orderTotalValue: parseFloat(orderTotalValue) || "",

        othersCustomerStatus: othersCustomer,
        addOnInvoiceStatus: addOnInv,
        invcustomerName: addOnInv
          ? getCustomerDetails?.invcustomerName || ""
          : "",

        invAddress: addOnInv ? getCustomerDetails?.invAddress || "" : "",

        invCityPostalCode: addOnInv
          ? getCustomerDetails?.invCityPostalCode || ""
          : "",

        invCustomerContactName: addOnInv
          ? getCustomerDetails?.invCustomerContactName || ""
          : "",
        invCustomerContactNumber: addOnInv
          ? getCustomerDetails?.invCustomerContactNumber || ""
          : "",

        otherCustomerContactName:
          getCustomerDetails?.otherCustomerContactName || "",
        otherCustomerContactNumber:
          getCustomerDetails?.otherCustomerContactNumber || "",

        companyAddress: [
          getCompanyDetails?.address,
          getCompanyDetails?.address2,
          getCompanyDetails?.address3,
          getCompanyDetails?.city,
          getCompanyDetails?.state,
        ]
          .filter(Boolean) // Removes falsy values (null, undefined, empty strings)
          .join(" "),
        companyPostalCode: getCompanyDetails?.cityPostalCode,
        companyCertifications: getCompanyDetails?.certifications,
        companyBankDetails: getCompanyDetails?.bandkDetails,
        companyContact: [
          { contant1: "9448380669" },
          { contant2: "7411677666" },
        ],
        companyMail: "svah2003@gmail.com",

        projectAddress: getProjectDetailsSave?.projectAddress,
        projectAddress2: getProjectDetailsSave?.projectAddress2,
        projectCity: getProjectDetailsSave?.projectCity,
        projectCityPostalCode: getProjectDetailsSave?.projectCityPostalCode,
        projectCode: getProjectDetailsSave?.projectCode,
        projectCodeDesc: getProjectDetailsSave?.projectCodeDesc,
        projectCountry: getProjectDetailsSave?.projectCountry,
        projectName: getProjectDetailsSave?.projectName,
        projectState: getProjectDetailsSave?.projectState,

        salesOfficerCode: userData?.userId,
        salesOfficerName: userData?.firstName,
        salesOfficerEmail: userData?.email,
        salesOfficerContactNr: userData?.contactNumber,

        items: filteredData,

        additionalCreditAmt: formInputs?.additionalCreditAmt || "",
      },
    };
    setDisabled(true);
    await ItemServiceV2.addOrderScheduleBookingV2(obj).then((item) => {
      if (item?.status === 200) {
        toast.success(item?.message || "added successfully", {
          duration: 2000,
          position: "top-right",
        });
        props.onHide();
      } else {
        // setErrorMsg('*'+ item?.message);
        toast.error(item?.message || "Please try again !!", {
          duration: 4000,
          position: "top-right",
        });
      }
      setDisabled(false);
    });
  };

  //Load Master Data
  const loadMasterData = async () => {
    // let obj = {};

    // if (getUserId === "A000") {
    //   obj.type = "ALL";
    // }
    // await ItemService.getCustomers(obj).then((item) => {
    //   // console.log(">> item! setCustomer title", item);
    //   if (item?.status === 200) {
    //     setCustomer(item?.data);
    //   } else {
    //     setCustomer([]);
    //     console.log(">> Error: Loading getCustomers");
    //   }
    // });

    let obj1 = {
      codeType: "companyCode",
    };
    await ItemService.getMasterData(obj1).then((item) => {
      // console.log(">> item! title", item);
      if (item?.status === 200) {
        setCompanyCode(item?.data);
      } else {
        setCompanyCode([]);
        console.log(">> Error: Loading Company Code");
      }
    });
  };

  const customerDataDropdown = async (code) => {
    let obj = {
      companyCode: code,
    };

    await ItemService.getCustomersByCompany(obj).then((item) => {
      if (item?.status === 200) {
        setCustomer(item?.data);
      } else {
        setCustomer([]);
        console.log(">> Error: Loading getCustomers");
      }
    });
  };

  // Onselect of Country state will load
  const getCustomerDetail = async (userId) => {
    let obj1 = {
      documentNumber: userId,
    };
    await ItemService.getCustomerDetail(obj1).then((item) => {
      if (item?.status === 200) {
        setCustomerDetails(item?.data[0] || null);
        // console.log(">>item",item?.data[0].customerCode || "" )
        laodCutomerExtendedPeriod(item?.data[0]?.customerCode || "");
      } else {
        setCustomerDetails([]);
        console.log(">> Error: Loading getProjectName");
      }
    });
  };

  // Onselect of Country state will load
  const getCompanyMaster = async (code) => {
    let obj1 = {
      code: code,
    };
    await ItemServiceV2.getCompanyMaster(obj1).then((item) => {
      if (item?.status === 200) {
        setCompanyDetails(item?.data[0] || null);
      } else {
        setCompanyDetails([]);
        console.log(">> Error: Loading getProjectName");
      }
    });
  };

  const getProjectNameData = async (userId) => {
    let obj1 = {
      userId: userId,
    };
    await ItemService.getProjectName(obj1).then((item) => {
      if (item?.status === 200) {
        const updatedData = item?.data?.map((item) => ({
          ...item,
          name: `${item.id} - ${item.projectAddress}`, // Combine id and name
        }));

        setProjects(updatedData || []);
      } else {
        setProjects([]);
        console.log(">> Error: Loading getProjectName");
      }
    });
  };

  // eslint-disable-next-line no-unused-vars
  const getProjectDetailsByCode = async (code) => {
    let obj = {
      userId: customerID,
      projectCode: code,
    };
    await ItemService.getProjectDetail(obj).then((item) => {
      if (item?.status === 200) {
        if (item?.data.length > 0) {
          setProjectDetails(
            item?.data[0]?.getLocations ? item?.data[0]?.getLocations[0] : [],
          );
          setProjectDetailsSave(item?.data[0]);
        } else {
          setProjectDetails([]);
        }
      } else {
        setProjectDetails([]);
        console.log(">> Error: Loading getProjectDetail");
      }
    });
  };

  // const handleGetSelectedMaterial = (selectedData) => {
  //   setProductDetailsData((prevData) => {
  //     const updatedData = [
  //       ...prevData,
  //       ...selectedData.map((item, index) => ({
  //         ...item,
  //         local_id: index + 1, // Continue local_id from previous data
  //         dispatchDate: getTodayDate(""),
  //         orderStatus: "Pending",
  //         orderQuantityLoad: "",
  //         shippingAddress: [
  //           getCustomerDetails?.address,
  //           getCustomerDetails?.address2,
  //           getCustomerDetails?.address3,
  //           getCustomerDetails?.state,
  //         ]
  //           .filter(Boolean) // Removes falsy values (null, undefined, empty strings)
  //           .join(" "),
  //         shippingPostalCode: getCustomerDetails?.cityPostalCode,

  //         customerAddress: [
  //           getCustomerDetails?.address,
  //           getCustomerDetails?.address2,
  //           getCustomerDetails?.address3,
  //           getCustomerDetails?.state,
  //         ]
  //           .filter(Boolean) // Removes falsy values (null, undefined, empty strings)
  //           .join(" "),
  //         customerPostalCode: getCustomerDetails?.cityPostalCode,
  //         certifications: getCustomerDetails?.certifications,

  //         companyAddress: [
  //           getCompanyDetails?.address,
  //           getCompanyDetails?.address2,
  //           getCompanyDetails?.address3,
  //           getCompanyDetails?.city,
  //           getCompanyDetails?.state,
  //         ]
  //           .filter(Boolean) // Removes falsy values (null, undefined, empty strings)
  //           .join(" "),
  //         companyPostalCode: getCompanyDetails?.cityPostalCode,
  //         companyCertifications: getCompanyDetails?.certifications,
  //       })),
  //     ];

  //     // Remove duplicates based on _id
  //     const uniqueData = Array.from(
  //       new Map(updatedData.map((item) => [item._id, item])).values()
  //     );

  //     // Sort based on `local_id`
  //     const sortedData = uniqueData
  //       .map((item, index) => ({
  //         ...item,
  //         local_id: index + 1, // Reset local_id sequentially
  //       }))
  //       .sort((a, b) => a.local_id - b.local_id);

  //     return sortedData;
  //   });
  // };

  //toggle Account button

  const handleGetSelectedMaterial = (selectedData) => {
    setProductDetailsData((prevData) => {
      const updatedData = [
        ...prevData,
        ...selectedData.map((item, index) => {
          const customerAddress = [
            getCustomerDetails?.address,
            getCustomerDetails?.address2,
            getCustomerDetails?.address3,
            getCustomerDetails?.state,
          ]
            .filter(Boolean)
            .join(" ");

          const postalCode = getCustomerDetails?.cityPostalCode;

          const defaultPriority = priority.find(
            (item) => item.name === "Medium",
          );

          return {
            ...item,
            local_id: index + 1,
            dispatchDate: getTodayDate(""),
            orderStatus: "Pending",
            orderQuantityLoad: "",

            priority: defaultPriority?.name || "",
            priorityCode: defaultPriority?.code || "",
            priorityDescription: defaultPriority?.name || "",

            // store internally
            shippingAddress: customerAddress,
            shippingPostalCode: Number(postalCode),

            // store original copy for reset
            originalShippingAddress: customerAddress,
            originalShippingPostalCode: postalCode,

            isShippingEdited: false,
            isPostalEdited: false,

            customerAddress,
            customerPostalCode: postalCode,
            certifications: getCustomerDetails?.certifications,

            companyAddress: [
              getCompanyDetails?.address,
              getCompanyDetails?.address2,
              getCompanyDetails?.address3,
              getCompanyDetails?.city,
              getCompanyDetails?.state,
            ]
              .filter(Boolean)
              .join(" "),
            companyPostalCode: getCompanyDetails?.cityPostalCode,
            companyCertifications: getCompanyDetails?.certifications,
          };
        }),
      ];

      const uniqueData = Array.from(
        new Map(updatedData.map((i) => [i._id, i])).values(),
      );

      const sortedData = uniqueData
        .map((item, index) => ({ ...item, local_id: index + 1 }))
        .sort((a, b) => a.local_id - b.local_id);

      return sortedData;
    });
  };

  const handleCheckboxChange = (local_id, event) => {
    const checkedValue = event.target.checked ? true : false;

    setProductDetailsData((prevRows) =>
      prevRows.map((row) =>
        row.local_id === local_id ? { ...row, accOnOff: checkedValue } : row,
      ),
    );
  };
  const handleDropdownChange = (data) => {
    setProductDetailsData((prevRows) =>
      prevRows.map((row) =>
        row.local_id === data.index
          ? {
              ...row,
              [data.name]: data.value,
              [data.code]: data.codeValue,
              [data.desc]: data.descValue,
            }
          : row,
      ),
    );
  };

  /* Modal Function */
  const addProductDetails = () => {
    const requiredFields = [];
    const anyFieldNotEmpty = Object.values(validation).some(
      (value) => value !== null && value !== "",
    );
    if (anyFieldNotEmpty) {
      requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
      return;
    }
    if (!validateRequired(formInputs.companyCode)) {
      requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
      setValidation((prev) => ({
        ...prev,
        companyCode: message.FILL_REQUIRED_FIELD,
      }));
      return;
    }
    if (!othersCustomer) {
      if (!validateRequired(formInputs.customerName)) {
        requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
        setValidation((prev) => ({
          ...prev,
          customerName: message.FILL_REQUIRED_FIELD,
        }));
        return;
      }
    } else {
      if (!validateRequired(getCustomerDetails?.customerName)) {
        requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
        setValidation((prev) => ({
          ...prev,
          customerName: message.FILL_REQUIRED_FIELD,
        }));
        return;
      }
      if (!validateRequired(getCustomerDetails?.address)) {
        requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
        setValidation((prev) => ({
          ...prev,
          address: message.FILL_REQUIRED_FIELD,
        }));
        return;
      }
      if (!validateRequired(getCustomerDetails?.cityPostalCode)) {
        requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
        setValidation((prev) => ({
          ...prev,
          cityPostalCode: message.FILL_REQUIRED_FIELD,
        }));
        return;
      }
      if (!validPostalCode(getCustomerDetails?.cityPostalCode)) {
        requiredFields.push(`${message.VALID_POSTAL_CODE}`);
        setValidation((prev) => ({
          ...prev,
          cityPostalCode: message.VALID_POSTAL_CODE,
        }));
        return;
      }
      if (!validateRequired(getCustomerDetails?.otherCustomerContactNumber)) {
        requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
        setValidation((prev) => ({
          ...prev,
          otherCustomerContactNumber: message.FILL_REQUIRED_FIELD,
        }));
        return;
      }
      if (
        !validateContactNumber(getCustomerDetails?.otherCustomerContactNumber)
      ) {
        requiredFields.push(`${message.VALID_CONTACT_NUMBER}`);
        setValidation((prev) => ({
          ...prev,
          otherCustomerContactNumber: message.VALID_CONTACT_NUMBER,
        }));
        return;
      }
    }
    setModalShow(true);
  };

  const hideModal = () => {
    setModalShow(false);
  };

  // const onInputChange = ({ target: { name, value } }) => {
  //   setFormInputs((formInputs) => ({ ...formInputs, [name]: value }));
  // };

  // const currentAvailableAmt =
  //   getCustomerDetails?.creditLimitAmt -
  //   getCustomerDetails?.creditOutStandingAmt -
  //   getCustomerDetails?.pendingOrderValue;

  // const currentAvailableAmt =
  //   getCustomerDetails?.companyProfile?.creditMaxLimit -
  //   getCustomerDetails?.companyProfile?.creditOutStandingAmt -
  //   getCustomerDetails?.pendingOrderValue;
  const currentAvailableAmt =
    getCustomerDetails?.companyProfile?.creditMaxLimit -
    (getCustomerDetails?.creditOutStandingAmt ?? 0) -
    (getCustomerDetails?.pendingOrderValue ?? 0) +
    Number(getCustomerDetails?.companyProfile?.limitToExtendedAmt ?? 0);
  //CreditPolicyRequestFormModal
  const showCreditPolicyRequestForm = () => {
    // setCreditPolicyFormData(items);
    setCreditPolicyFormModal(true);
  };

  const hideCreditPolicyRequestForm = () => {
    setCreditPolicyFormModal(false);
  };

  const hideFailureModal = () => {
    setShowFailureModal(false);
  };

  //validation for  credit availeble limit
  // useEffect(() => {

  //   const orderValue =
  //     parseFloat(orderTotalValue?.toString().replace(/,/g, "")) || 0;
  //   const available =
  //     parseFloat(currentAvailableAmt?.toString().replace(/,/g, "")) || 0;

  //   if (orderValue > available) {
  //     setErrorFields([
  //       "Your Order value is greater than the available amount. Kindly create a credit limit extension request.",
  //     ]);
  //     setShowFailureModal(true);
  //     setDisabled(true);
  //     setToggleCreditRequest(true);

  //     setValidation((prev) => ({
  //       ...prev,
  //       orderTotalValue: "Order value exceeds available amount.",
  //     }));
  //   } else {
  //     setErrorFields([]);
  //     setShowFailureModal(false);
  //     setDisabled(false);
  //     setToggleCreditRequest(false);

  //     setValidation((prev) => {
  //       const { orderTotalValue, ...rest } = prev;
  //       return rest;
  //     });
  //   }
  // }, [orderTotalValue, currentAvailableAmt, getProductDetailsData]);

  useEffect(() => {
    setOrderTotalValue("");
  }, [getCustomerDetails]);

  useEffect(() => {
    // 1️⃣ Skip validation if order value is empty
    if (
      orderTotalValue === "" ||
      orderTotalValue === null ||
      orderTotalValue === undefined ||
      Number(orderTotalValue) === 0
    ) {
      setErrorFields([]);
      setShowFailureModal(false);
      setDisabled(false);
      setToggleCreditRequest(false);

      setValidation((prev) => {
        const { orderTotalValue, currentAvailableAmt, ...rest } = prev;
        return rest;
      });

      return;
    }

    // 2️⃣ OTHERS CUSTOMER → No credit validation at all
    if (othersCustomer) {
      setErrorFields([]);
      setShowFailureModal(false);
      setDisabled(false);
      setToggleCreditRequest(false);

      setValidation((prev) => {
        const { orderTotalValue, currentAvailableAmt, ...rest } = prev;
        return rest;
      });

      return; // 🔑 very important
    }

    // 3️⃣ Normal customer → Credit validation
    const availableAmt = Number(
      getCustomerDetails?.companyProfile?.creditAvailableAmt ??
        getCustomerDetails?.creditAvailableAmt ??
        0,
    );

    // CASE 1 → No available amount
    if (availableAmt === 0 || isNaN(availableAmt)) {
      setErrorFields([
        "No current available amount, Kindly create a credit limit extension request.",
      ]);
      setShowFailureModal(true);
      setDisabled(true);
      setToggleCreditRequest(true);

      // setValidation((prev) => ({
      //   ...prev,
      //   currentAvailableAmt:
      //     "No current available amount. Kindly create a credit limit extension request.",
      // }));
      return;
    }

    setErrorFields([]);
    setShowFailureModal(false);
    setDisabled(false);
    setToggleCreditRequest(false);

    setValidation((prev) => {
      const { orderTotalValue, currentAvailableAmt, ...rest } = prev;
      return rest;
    });
    // eslint-disable-next-line
  }, [orderTotalValue, othersCustomer]);

  //
  const [creditExtendedShow, setCreditExtendedShow] = useState(false);
  const [extendPeriodData, setExtendPeriodData] = useState([]);
  const extendPeriodColumn = [
    {
      name: "Sl.no",
      selector: (row, index) => index + 1,
      cell: (row, index) => <>{index + 1}</>,
      sortable: false,
      width: "100px",
    },
    {
      name: "Extended Amt",
      selector: (row) => row?.limitToExtendedAmt || "--",
      cell: (row) => <>{row?.limitToExtendedAmt}</>,
      sortable: true,
      width: "140px",
    },
    {
      name: "Extended Days",
      selector: (row) => row?.periodToExtendedDays || "--",
      cell: (row) => <>{row?.periodToExtendedDays}</>,
      sortable: true,
      width: "140px",
    },
    {
      name: "Status",
      selector: (row) => row?.cpHeaderStatus || "--",
      cell: (row) => (
        <>
          <TableStatusField status={row?.cpHeaderStatus} />
        </>
      ),
      sortable: true,
      width: "160px",
    },
    {
      name: "Credit Limit",
      selector: (row) => row?.companyProfile?.creditMaxLimit || "--",
      cell: (row) => (
        <div>
          <span>{row?.companyProfile?.creditMaxLimit}</span>
        </div>
      ),
      sortable: true,
      width: "130px",
    },
    {
      name: "Update At",
      selector: (row) => row?.updatedAt || "--",
      cell: (row) => (
        <div>
          <span>{formatDateWithAMPM(row?.updatedAt)}</span>
        </div>
      ),
      sortable: true,
      width: "140px",
    },
    {
      name: "Remark",
      selector: (row) => row?.remark || "--",
      cell: (row) => (
        <div>
          <span>{row?.remark}</span>
        </div>
      ),
      sortable: true,
      width: "130px",
    },
  ];
  const toggleCreditExtended = () => {
    setCreditExtendedShow(!creditExtendedShow);
  };

  //extend period
  const laodCutomerExtendedPeriod = async (customerId) => {
    const obj = {
      queryName: "getCreditPolicyListbyCustomer",
      rowFilter: {
        $and: [
          {
            customerId: customerId,
          },
        ],
      },
      page: 1,
      per_page: 99999,
    };
    await ItemServiceV2.generateCustomerQuery(obj).then((item) => {
      if (item?.status === 200) {
        toast.success(item?.message || "Customer Extend Period Load ", {
          duration: 2000,
          position: "top-right",
        });
        setExtendPeriodData(item?.data);
      } else {
        // setErrorMsg('*'+ item?.message);
        toast.error(item?.message || "Please try again !!", {
          duration: 4000,
          position: "top-right",
        });
      }
    });
  };

  return (
    <Modal
      show={props.show}
      onHide={props.onHide}
      aria-labelledby="contained-modal-title-vcenter"
      dialogClassName="modal-90w"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          Order Booking
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="accordion mb-4" id="accordionExample">
          <div className="accordion-item">
            <h2 className="accordion-header">
              <Row className="accordion-button">
                <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                  <i
                    className={`bi ${
                      isCardVisible1 ? "bi-chevron-down" : "bi-chevron-right"
                    }`}
                    onClick={toggleCardVisibility1}
                  ></i>
                </Col>
                <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                  <span className="iconLogo">CD</span>
                </Col>
                <Col xs={8} md={9} lg={9}>
                  <span className="headerTitle">Customer Details</span>
                  <span className="subHeaderTitle">Customer Details</span>
                </Col>
              </Row>
            </h2>

            <div
              className={`accordion-collapse collapse show ${
                isCardVisible1 ? "visible" : ""
              }`}
            >
              <div className="accordion-body">
                <Row className="pt-2 pb-4 d-flex align-items-center">
                  <Row>
                    <Col xs={12} md={4} lg={4} className="commLeftRightPadding">
                      <ComboboxField
                        label="Company Name"
                        placeholder=""
                        data={getCompanyCode}
                        id="companyCode"
                        iconClassName="dropdownIcon"
                        name="companyCode"
                        code="companyCode"
                        description="companyCodeDesc"
                        setValue={formInputs.companyCode || ""}
                        getvalue={setDropdownData}
                        required={true}
                        error={validation.companyCode}
                      />
                    </Col>
                    <Col xs={12} md={4} lg={4} className="commLeftRightPadding">
                      <TextAreaField
                        className="inputBox"
                        label="Company Address"
                        name="companyAddress"
                        value={[
                          getCompanyDetails?.address,
                          getCompanyDetails?.address2,
                          getCompanyDetails?.address3,
                          getCompanyDetails?.city,
                          getCompanyDetails?.state,
                        ]
                          .filter(Boolean)
                          .join(" ")}
                        disabled={true}
                      />
                    </Col>
                  </Row>

                  <Row>
                    {!othersCustomer && (
                      <>
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commLeftRightPadding"
                        >
                          <ComboboxField
                            label="Customer Name"
                            placeholder=""
                            data={getCustomer}
                            id="customerName"
                            iconClassName="dropdownIcon"
                            name="customerName"
                            code="customerCode"
                            description="customerNameDesc"
                            setValue={formInputs?.customerName || ""}
                            getvalue={setDropdownData}
                            required={true}
                            error={validation.customerName}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commLeftRightPadding"
                        >
                          <TextAreaField
                            className="inputBox"
                            label="Customer Address"
                            name="projectAddress"
                            value={[
                              getCustomerDetails?.address,
                              getCustomerDetails?.address2,
                              getCustomerDetails?.address3,
                              getCustomerDetails?.state,
                              getCustomerDetails?.cityPostalCode,
                            ]
                              .filter(Boolean) // Removes falsy values (null, undefined, empty strings)
                              .join(" ")}
                            // onChange={onInputChange}
                            disabled={true}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commLeftRightPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Customer Code"
                            id="customerCode"
                            name="customerCode"
                            // type="text"
                            value={getCustomerDetails?.customerCode}
                            onChange={othersOnInputChange}
                            disabled={true}
                            // required={true}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commLeftRightPadding d-flex align-items-center"
                        >
                          <input
                            className="form-check-input"
                            type="checkbox"
                            // role="othersCustomer"
                            // data-role="othersCustomer"
                            id="othersCustomer"
                            checked={othersCustomer}
                            // checked={othersCustomer === "true"}
                            onChange={onCheckBoxChange}
                          />
                          <p className="m-0 ps-1 fw-medium text-dark ">
                            Others{" "}
                          </p>
                        </Col>
                      </>
                    )}
                  </Row>
                  {othersCustomer && (
                    <Row>
                      <Col
                        xs={12}
                        md={12}
                        lg={12}
                        className="commLeftRightPadding d-flex align-items-center"
                      >
                        <input
                          className="form-check-input"
                          type="checkbox"
                          // role="othersCustomer"
                          // data-role="othersCustomer"
                          id="othersCustomer"
                          checked={othersCustomer}
                          // checked={othersCustomer === "true"}
                          onChange={onCheckBoxChange}
                        />
                        <p className="m-0 ps-1 fw-medium text-dark ">Others </p>
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commLeftRightPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Customer Name"
                          id="customerName"
                          name="customerName"
                          // type="text"
                          value={getCustomerDetails?.customerName}
                          onChange={othersOnInputChange}
                          // disabled={false}
                          required={true}
                          error={validation.customerName}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commLeftRightPadding"
                      >
                        <TextAreaField
                          className="inputBox"
                          label="Address"
                          id="address"
                          name="address"
                          value={getCustomerDetails?.address}
                          onChange={othersOnInputChange}
                          // disabled={false}
                          error={validation.address}
                        />
                      </Col>

                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commLeftRightPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Pin Code"
                          id="cityPostalCode"
                          name="cityPostalCode"
                          // type="text"
                          value={getCustomerDetails?.cityPostalCode}
                          onChange={othersOnInputChange}
                          // disabled={false}
                          error={validation.cityPostalCode}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commLeftRightPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Contact Name"
                          id="otherCustomerContactName"
                          name="otherCustomerContactName"
                          // type="text"
                          value={getCustomerDetails?.otherCustomerContactName}
                          onChange={othersOnInputChange}
                          // disabled={false}
                          // error={validation.shippingPostalCode}
                        />
                      </Col>

                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commLeftRightPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Contact Number"
                          id="otherCustomerContactNumber"
                          name="otherCustomerContactNumber"
                          // type="text"
                          value={getCustomerDetails?.otherCustomerContactNumber}
                          onChange={othersOnInputChange}
                          // disabled={false}
                          error={validation.otherCustomerContactNumber}
                        />
                      </Col>
                    </Row>
                  )}
                  <Col
                    xs={12}
                    md={12}
                    lg={12}
                    className="commLeftRightPadding d-flex align-items-center"
                  >
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id="addOnInv"
                      checked={addOnInv}
                      onChange={addOnInvoiceChange}
                    />
                    <p className="m-0 ps-1 fw-medium text-dark ">
                      Add-on Invoice{" "}
                    </p>
                  </Col>
                  {addOnInv && (
                    <>
                      <Col
                        xs={12}
                        md={6}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Inv Customer Name"
                          id="invcustomerName"
                          name="invcustomerName"
                          value={getCustomerDetails?.invcustomerName}
                          onChange={othersOnInputChange}
                          required={true}
                          error={validation.invcustomerName}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={6}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <TextAreaField
                          className="inputBox"
                          label="Inv Address"
                          id="invAddress"
                          name="invAddress"
                          value={getCustomerDetails?.invAddress}
                          onChange={othersOnInputChange}
                          error={validation.invAddress}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={6}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Inv Pin Code"
                          id="invCityPostalCode"
                          name="invCityPostalCode"
                          value={getCustomerDetails?.invCityPostalCode}
                          onChange={othersOnInputChange}
                          error={validation.invCityPostalCode}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={6}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Contact Name"
                          id="invCustomerContactName"
                          name="invCustomerContactName"
                          value={getCustomerDetails?.invCustomerContactName}
                          onChange={othersOnInputChange}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={6}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Contact Number"
                          id="invCustomerContactNumber"
                          name="invCustomerContactNumber"
                          value={getCustomerDetails?.invCustomerContactNumber}
                          onChange={othersOnInputChange}
                          error={validation.invCustomerContactNumber}
                        />
                      </Col>
                    </>
                  )}
                </Row>
              </div>
            </div>
          </div>
        </div>
        {!othersCustomer && (
          <>
            {getCustomerDetails && (
              <div className="accordion mb-4" id="accordionExample">
                <div className="accordion-item">
                  <h2 className="accordion-header">
                    <Row className="accordion-button">
                      {/* Arrow */}
                      <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                        <i
                          className={`bi ${
                            isCardVisible3
                              ? "bi-chevron-down"
                              : "bi-chevron-right"
                          }`}
                          onClick={toggleCardVisibility3}
                        ></i>
                      </Col>

                      {/* Logo */}
                      <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                        <span className="iconLogo">CL</span>
                      </Col>

                      {/* Labels */}
                      <Col xs={8} md={9} lg={9}>
                        <span className="headerTitle">
                          Customer Credit Limit
                        </span>
                        <span className="subHeaderTitle">
                          Credit Limit Details
                        </span>
                      </Col>
                    </Row>
                  </h2>

                  <div
                    className={`accordion-collapse collapse show ${
                      isCardVisible3 ? "visible" : ""
                    }`}
                  >
                    <div className="accordion-body">
                      <Row className="pt-2 pb-4 d-flex align-items-center">
                        <Row>
                          {/* 1. Credit Limit Amt */}
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commLeftRightPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Credit Limit Amt"
                              id="creditLimitAmt"
                              name="creditLimitAmt"
                              // value={
                              //   getCustomerDetails?.creditLimitAmt ??
                              //   getCustomerDetails?.companyProfile
                              //     ?.creditMaxLimit
                              // }
                              value={
                                getCustomerDetails?.companyProfile
                                  ?.creditMaxLimit
                              }
                              disabled={true}
                              error={validation.creditLimitAmt}
                            />
                          </Col>

                          {/* 2. Current Outstanding Amt */}
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commLeftRightPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Current Outstanding Amt (Invoice)"
                              id="creditOutStandingAmt"
                              name="creditOutStandingAmt"
                              value={
                                getCustomerDetails?.creditOutStandingAmt ?? 0
                                //  ?? currentOutstandingAmt
                              }
                              //  value={
                              //   currentOutstandingAmt
                              //   // getCustomerDetails?.creditOutStandingAmt ?? "0"
                              //   // getCustomerDetails?.companyProfile?.creditOutStandingAmt
                              // }
                              disabled={true}
                              error={validation.creditOutStandingAmt}
                            />
                          </Col>

                          {/* 3. Credit Period */}
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commLeftRightPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Credit Period (Days)"
                              id="creditPeriod"
                              name="creditPeriod"
                              // value={
                              //   getCustomerDetails?.creditPeriod ??
                              //   getCustomerDetails?.companyProfile?.creditPeriod
                              // }
                              value={
                                getCustomerDetails?.companyProfile?.creditPeriod
                              }
                              disabled={true}
                              error={validation.creditPeriod}
                            />
                          </Col>

                          {/* 4. Order Value */}
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commLeftRightPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Order Value"
                              id="orderTotalValue"
                              name="orderTotalValue"
                              value={orderTotalValue}
                              disabled={true}
                              error={validation.orderTotalValue}
                            />
                          </Col>

                          {/* 5. Pending Order Amt */}
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commLeftRightPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Current Order Amt (No Invoice)"
                              id="pendingOrderValue"
                              name="pendingOrderValue"
                              value={
                                getCustomerDetails?.pendingOrderValue ?? 0
                                // getCustomerDetails?.companyProfile?.pendingOrderValue
                              }
                              // value={
                              //   getCustomerDetails?.companyProfile?.pendingOrderValue // value is not comming
                              // }
                              disabled={true}
                            />
                          </Col>

                          {/* 6. Current Available Amt */}
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commLeftRightPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Credit Available Amt + Extended Amt"
                              id="currentAvailableAmt"
                              name="currentAvailableAmt"
                              value={currentAvailableAmt}
                              disabled={true}
                              error={validation.currentAvailableAmt}
                            />
                            {/* {currentAvailableAmt ? (
                              <InputField
                                className="inputBox"
                                label="Credit Available Amt"
                                id="currentAvailableAmt"
                                name="currentAvailableAmt"
                                value={currentAvailableAmt}
                                disabled={true}
                                error={validation.currentAvailableAmt}
                              />
                            ) : (
                              <InputField
                                className="inputBox"
                                label="Current Available Amt"
                                id="creditAvailableAmt"
                                name="creditAvailableAmt"
                                value={
                                  getCustomerDetails?.creditAvailableAmt ??
                                  getCustomerDetails?.companyProfile
                                    ?.creditAvailableAmt
                                }
                                // value={
                                //   getCustomerDetails?.companyProfile
                                //     ?.creditAvailableAmt
                                // }
                                disabled={true}
                                error={validation.currentAvailableAmt}
                              />
                            )} */}
                          </Col>

                          {/* 7. Limit to be Extended (Amount) */}
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox text-danger"
                              label="Limit to be Extended (Amount)"
                              name="limitToExtendedAmt"
                              // value={formInputs?.limitToExtendedAmt ?? getCustomerDetails?.companyProfile
                              //       ?.limitToExtendedAmt ?? ""}
                              value={
                                getCustomerDetails?.companyProfile
                                  ?.limitToExtendedAmt ?? ""
                              }
                              disabled={true}
                            />
                          </Col>

                          {/* 8. Period to be Extended (Days) */}
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox text-danger"
                              label="Period to be Extended (Days)"
                              name="periodToExtendedDays"
                              // value={formInputs?.periodToExtendedDays ?? getCustomerDetails?.companyProfile
                              //       ?.periodToExtendedDays?? ""}
                              value={
                                getCustomerDetails?.companyProfile
                                  ?.periodToExtendedDays ?? ""
                              }
                              disabled={true}
                            />
                          </Col>
                          <Row>
                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <button
                                className="btn btn-table"
                                onClick={toggleCreditExtended}
                              >
                                Credit Extended
                              </button>
                            </Col>
                          </Row>
                          {/* 9. Credit Request Button */}
                          {toggleCreditRequest && (
                            <Row className="mt-4 mr-4">
                              <Col
                                xs={12}
                                md={2}
                                lg={2}
                                className="headerButtonAlign"
                              >
                                <button
                                  className="btn btnInfo mr-4"
                                  onClick={() => showCreditPolicyRequestForm()}
                                >
                                  Credit Request
                                </button>
                              </Col>
                            </Row>
                          )}
                        </Row>
                      </Row>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </>
        )}
        {/* Credit Extended List */}
        {creditExtendedShow && (
          <div
            className="accordion sri-venkateshwara mb-4"
            id="accordionExample"
          >
            <div className="accordion-item">
              <h2 className="accordion-header">
                <Row className="accordion-button">
                  <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                    <i
                      className={`bi ${
                        isCardVisible2 ? "bi-chevron-right" : "bi-chevron-down"
                      }`}
                      onClick={toggleCardVisibility2}
                    ></i>
                  </Col>
                  <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                    <span className="iconLogo">CE</span>
                  </Col>
                  <Col xs={12} md={8} lg={8}>
                    <span className="headerTitle"> Credit Extended List </span>
                    <span className="subHeaderTitle">
                      Credit Extended List Details
                    </span>
                  </Col>
                </Row>
              </h2>
              <div
                // id="acc"
                className={`accordion-collapse collapse show ${
                  isCardVisible2 ? "visible" : ""
                }`}
                // aria-labelledby="headingOne"
                // data-bs-parent="#accordionExample"
              >
                <div className="accordion-body">
                  <Row>
                    <Col xs={12} md={12} lg={12}>
                      <DataTable
                        title=""
                        columns={extendPeriodColumn}
                        data={extendPeriodData}
                        // progressPending={loading}
                        // paginationRowsPerPageOptions={Constants.ROW_PER_PAGE}
                        pagination
                        // paginationServer
                        // paginationTotalRows={totalRows}
                        // onChangeRowsPerPage={handlePerRowsChange}
                        // onChangePage={handlePageChange}
                        // selectableRows
                        // onSelectedRowsChange={handleChange}
                      />
                    </Col>
                  </Row>
                </div>
              </div>
            </div>
          </div>
        )}
        {/* table */}
        <div className="accordion sri-venkateshwara mb-4" id="accordionExample">
          <div className="accordion-item">
            <h2 className="accordion-header">
              <Row className="accordion-button">
                <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                  <i
                    className={`bi ${
                      isCardVisible2 ? "bi-chevron-right" : "bi-chevron-down"
                    }`}
                    onClick={toggleCardVisibility2}
                  ></i>
                </Col>
                <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                  <span className="iconLogo">PD</span>
                </Col>
                <Col xs={12} md={8} lg={8}>
                  <span className="headerTitle">Product Details</span>
                  <span className="subHeaderTitle">Product Details</span>
                </Col>

                <Col xs={12} md={2} lg={2} className="headerButtonAlign">
                  <button className="btnTable" onClick={addProductDetails}>
                    <i className="bi bi-plus-lg"></i> Add
                  </button>
                </Col>
              </Row>
            </h2>
            <div
              // id="acc"
              className={`accordion-collapse collapse show ${
                isCardVisible2 ? "visible" : ""
              }`}
              // aria-labelledby="headingOne"
              // data-bs-parent="#accordionExample"
            >
              <div className="accordion-body">
                <Row>
                  <Col xs={12} md={12} lg={12}>
                    <DataTable
                      title=""
                      columns={getProductDetailsCol}
                      data={getProductDetailsData}
                      // progressPending={loading}
                      // paginationRowsPerPageOptions={Constants.ROW_PER_PAGE}
                      pagination
                      // paginationServer
                      // paginationTotalRows={totalRows}
                      // onChangeRowsPerPage={handlePerRowsChange}
                      // onChangePage={handlePageChange}
                      // selectableRows
                      // onSelectedRowsChange={handleChange}
                    />
                  </Col>
                </Row>
              </div>
            </div>
          </div>
          <Row className="mt-4">
            <Col xs={12} md={2} lg={2} className="headerButtonAlign">
              <button
                className="btn btnInfo"
                onClick={handleSave}
                disabled={disable}
              >
                Save
              </button>
            </Col>
          </Row>
        </div>
        <MaterialSelectionModal
          show={modalShow}
          onHide={() => hideModal()}
          onselectedcatdata={handleGetSelectedMaterial}
        />
        <CreditPolicyRequestFormOrderBookingModal
          show={getCreditPolicyFormModal}
          onHide={() => hideCreditPolicyRequestForm()}
          getCustomerDetails={getCustomerDetails}
          getCompanyDetails={getCompanyDetails}
          currentAvailableAmt={currentAvailableAmt}

          // onSuccess={() => handleSearchFuncApi()}
        />
        <FailureModal
          show={getShowFailureModal}
          onHide={() => hideFailureModal()}
          failuremodaldata={getFailureModal}
          requiredfields={getErrorFields}
        />
      </Modal.Body>
    </Modal>
  );
});

export default OrderSchedulingModal;
